module.exports = __webpack_public_path__ + "static/media/m_beard_tailored_diamond__v_shadow.2e63ab23.png";